import StartPod from "./StartPod";

const StartPodPage = () => {
  return (
    <>
      <div align={"center"}>
        <StartPod />
      </div>
    </>
  );
};

export default StartPodPage;
